import { StageCandidateStatus } from 'generated/graphql';
import { FC } from 'react';
import ReportsManagement from 'views/User/UserDetails/UserMainResets/UserReset/StageReset/ReportsManagement/ReportsManagement';
import { IStageReset } from '../UserResets.interface';
import styles from './StageManagement.module.scss';

const StageManagement: FC<IStageReset> = ({
  userInfo,
  stageId,
  projectId,
  stageStatus,
  stageCandidateId,
  companyId,
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <ReportsManagement
          companyId={companyId}
          projectId={projectId}
          stageId={stageId}
          isDisabled={stageStatus !== StageCandidateStatus.Completed}
          stageCandidateId={stageCandidateId}
        />
      </div>
    </div>
  );
};

export default StageManagement;
